import { FunctionsHttpError } from '@supabase/supabase-js';

export interface EdgeFunctionErrorDetails {
  status?: number;
  body?: string;
}

const MAX_BODY_LENGTH = 500;

export const getEdgeFunctionErrorDetails = async (
  error: unknown,
): Promise<EdgeFunctionErrorDetails> => {
  if (!(error instanceof FunctionsHttpError)) {
    return {};
  }

  const response: unknown = error.context;

  if (!(response instanceof Response)) {
    return {};
  }

  try {
    const body = await response.clone().text();

    return { status: response.status, body: body.slice(0, MAX_BODY_LENGTH) };
  } catch {
    return { status: response.status };
  }
};
